<template>
  <component :curLayout="getLayout" :singlePageFlag="singlePageFlag"
             class="w100b h100b"
             :analysisSet="analysisSet"
             :style="{'--left-menu-width':getLeftMenuWidth+'px'}"
             :settingLayout="settingLayout" :is="getLayout"></component>
</template>


<script lang="ts">
import {defineComponent, unref,onUnmounted} from "vue";
import componentsCtls from '../layoutFrame/index';
import {useLayout} from '../../hooks/layouts/useLayout';
import {StorageUtils} from 'xmgoing-utils';
import {useRootSetting} from "@/hooks/setting/useRootSetting";

const layoutList:any=[];
Object.keys(componentsCtls).forEach((propName)=>{
  layoutList.push(propName);
});

export default defineComponent({
  name: "defaultLayouts",
  props: {
    analysisSet:{
      type:Boolean,
      default:false
    },
    singlePageFlag:{},
    settingLayout:{
      type:Boolean,
      default:true
    },
    useLayout:String,
    msg: String,
  },
  components: {
    ...componentsCtls,
  },
  setup(props) {
    StorageUtils.addSessionItem("showApp","false");
    StorageUtils.addSessionItem("templateId","");

    const {getBaseSpace, getBaseBorderRaduis,getBaseFontSize,getLeftMenuWidth } = useRootSetting();
    const { setting,getLayout } =  useLayout(props,layoutList);
    StorageUtils.addItem("getLayout", unref(getLayout));
    onUnmounted(()=>{
      StorageUtils.addItem("getLayout", unref(getLayout));
    })

    return {
      getBaseSpace,
      getLeftMenuWidth,
      getBaseBorderRaduis,
      getBaseFontSize,
      setting,
      getLayout
    };
  },
});
</script>
<style  lang="less">


</style>
